import React, { useContext, useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";

import Login_Green_Btn from "../../Common-Component/common_btn/login_green_btn/Login_Green_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import classNames from "classnames";
import { Context } from "../../../utils/context";
import { useForm } from "react-hook-form";
import {
  Login,
  LoginSendOtp,
  LoginVerifyOtp,
} from "../../../utils/apis/login/Login";
import { loginCart } from "../../../utils/apis/addToCart/addToCart";
import Success_Modal_2 from "../success_modal2/Success_Modal_2";
import { Form } from "react-bootstrap";
import { RegxExpression } from "../../../utils/common";

const Login_Form = ({
  setSuccessModalShow,
  onHide,
  setFormType,
  setSuccessText,
  ...props
}) => {
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isResending, setIsResending] = useState(false);

  

  const handleResendOtp = () => {
    if (timer === 0) {
      setTimer(10); // restart timer
      setIsResending(true);

      // OPTIONAL: call resend OTP API here

      setTimeout(() => setIsResending(false), 1000);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const handleSendOtp = async (data) => {
    
    clearErrors("");
    const res = await LoginSendOtp(data);
    if (res.success) {
      setShowOtp(true);
      setTimer(60);
    } else {
      setError("otp", {
        type: "required",
        message: res?.message,
      });
    }
  };

  useEffect(() => {
    let interval = null;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const [showPassword, setShowPassword] = useState(false);
  const {
    signin,
    setSignin,
    shimmerLoader,
    setShimmerLoader,
    IMG_URL,
    setSigninGoogle,
    signinGoogle,
  } = useContext(Context);

  const onSubmit = async (data) => {
   

    if (!data.otp) {
      setError("otp", {
        type: "required",
        message: "verify OTP",
      });
      return;
    }
    setShimmerLoader(true);
    const res = await LoginVerifyOtp(data);

    if (res?.success) {
      await Cookies.set("local_mandai_security", res?.data?.token);
      setSignin(true);
      await loginCart();
      onHide();
      setSuccessModalShow(true);
      setSuccessText("Logged In SuccessFully...!");
      setTimeout(() => {
        setSuccessModalShow(false);
        setShimmerLoader(false);
        // navigate(-1);
          navigate("/");
      }, 3000);
    } else {
      setShimmerLoader(false);
      setError("otp", {
        type: "required",
        message: "Invalid OTP",
      });
      
    }
  };

  function googleLogin() {
    const backendURL = process.env.REACT_APP_BASE_URL;
    const path = "/auth/google";
    // Dynamically construct the full URL
    const dynamicURL = `${backendURL}${path}`;
    // Open the URL in the current window
    window.open(dynamicURL, "_self"); // "_self" opens in the same tab
    setSigninGoogle(true);

    // setModalShow(true);
    setTimeout(() => {
      // setModalShow(false);
      setShimmerLoader(false);
      navigate(-1);
    }, 1000);
  }

  useEffect(() => {
    if (timer === 0) {
      setShowOtp(false);
    }
  }, [timer]);

  return (
    <div className="Login_Form">
      <>
        <div className="logo_content">
          <div className="logo_holder">
            <img
              src="/assets/Image/Logo/Local-MandaiFinal-Logo.png"
              className="logo_img"
            />
          </div>
          <p className="modal_haeding">GET YOUR NEEDS FULLFILLED!</p>
        </div>

        <div className="form_holder">
          <Form>
            <Form.Group className="input_group" controlId="">
              <div className="password_holder">
                <Form.Control
                  type="text"
                  name="contact_no"
                  placeholder="Enter Mobile Number"
                  {...register("contact_no", {
                    required: "Mobile Number is required",
                    minLength: {
                      value: 10,
                      message: "Number should be at least 10 characters",
                    },
                  })}
                  onKeyDown={(event) => {
                    if (!RegxExpression.phone.test(event.key)) {
                      if (event.key !== "Backspace") {
                        event.preventDefault();
                      }
                    }
                  }}
                  maxLength={10}
                />

                {!showOtp && (
                  <div
                    className="eye-icc verify_text"
                    onClick={() => {
                      const contactNo = getValues("contact_no")?.trim();

                      // Required check
                      if (!contactNo) {
                        setError("contact_no", {
                          type: "required",
                          message: "Contact number is required",
                        });
                        return;
                      }

                      if (!/^[6-9]\d{9}$/.test(contactNo)) {
                        setError("contact_no", {
                          type: "pattern",
                          message: "Enter a valid 10 digit mobile number",
                        });
                        return;
                      }

                      handleSendOtp({ contact_no: contactNo });
                    }}
                  >
                    Send Otp
                  </div>
                )}
              </div>
            </Form.Group>
            {errors?.contact_no && (
              <sup className="text-danger">{errors?.contact_no?.message}</sup>
            )}
            {showOtp && (
              <Form.Group className="input_group" controlId="">
                <div className="password_holder">
                  <Form.Control
                    type={showPassword ? "text" : "text"}
                    placeholder="Enter OTP*"
                    name="OTP"
                    {...register("otp", {
                      required: "OTP is required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.password,
                      "is-valid": getValues("password"),
                    })}
                  />
                </div>
              </Form.Group>
            )}
            {errors?.otp && (
              <div className="mt-2">
                <sup className="text-danger">{errors?.otp?.message}</sup>
              </div>
            )}

            {showOtp && (
              <div className="otp_field_holder">
                {/* <div className="otp_field">
                  <Form.Control className="otp_form_field" maxLength={1} />
                  <Form.Control className="otp_form_field" maxLength={1} />
                  <Form.Control className="otp_form_field" maxLength={1} />
                  <Form.Control className="otp_form_field" maxLength={1} />
                </div> */}

                <div className="resend_text_holder">
                  <div className="resend_holder">
                    <p>
                      {/* <span
                        onClick={() => {
                          const contactNo = getValues("contact_no");

                            if (!contactNo) {
                              setError("contact_no", {
                                type: "required",
                                message: "Contact number is required",
                              });
                              return;
                            }

                            handleSendOtp({ contact_no: contactNo });
                          }}
                          style={{
                            cursor: timer === 0 ? "pointer" : "not-allowed",
                          }}
                        >
                          Resend OTP{" "}
                        </span>
                      )}

                          handleSendOtp({ contact_no: contactNo });
                        }}
                        style={{
                          cursor: timer === 0 ? "pointer" : "not-allowed", color: "#000", marginRight: "5px",
                        }}
                      >
                        Resend OTP{" "}
                      </span> */}
                      <span
                        style={{
                          cursor: timer === 0 ? "pointer" : "not-allowed",
                          color: "#000",
                          marginRight: "5px",
                        }}
                      >
                        OTP Valid For{" "}
                      </span>
                      {timer > 0 && (
                        <span style={{ textDecoration: "underline" }}>
                          00:{timer < 10 ? `0${timer}` : timer} Sec
                        </span>
                      )}
                    </p>
                  </div>

                  {/* <div className="verify_holder">
                    <p>Verify</p>
                  </div> */}
                </div>
              </div>
            )}

            {/* <p
              className="forgot_text"
              onClick={() => {
                setFormType("forgot");
              }}
            >
              Forgot Password?
            </p> */}

            <div className="submit_btn_div">
              <Login_Green_Btn
                btn_name="Log In"
                onClick={handleSubmit(onSubmit)}
              />
            </div>

            {/* <p
              className="create_acc_text"
              onClick={() => {
                setFormType("signup");
              }}
            >
              Create Account?
            </p> */}
          </Form>
        </div>
      </>
    </div>
  );
};

export default Login_Form;
